import type { AxiosError } from 'axios';

interface ApiErrorPayload {
  error?: string;
  errorCode?: string;
  message?: string;
}

export function getApiErrorCode(error: unknown): string | null {
  const axiosError = error as AxiosError<ApiErrorPayload>;
  return axiosError?.response?.data?.errorCode ?? null;
}

/** Extract the human-readable error message returned by the backend, if any. */
export function getApiErrorMessage(error: unknown): string | null {
  const axiosError = error as AxiosError<ApiErrorPayload>;
  const data = axiosError?.response?.data;
  return data?.error ?? data?.message ?? null;
}
